import React from 'react';
import { BaseLayerView } from '@/framework';
import { IRenderLayerProps } from '@/version-types';

const GroupLayer: React.FC<IRenderLayerProps> = ({ layer, isNavigator }) => {
    return (
        <>
            {/* 渲染一个组的信息 */}
            <BaseLayerView isNavigator={isNavigator} layer={layer}>
                {/* <div style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.1)' }}></div> */}
            </BaseLayerView>
            {/* 组内容渲染交给每个图层 */}
            {/* {res} */}
        </>
    );
};
export default React.memo(GroupLayer);
